/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import constants from 'one_mubi/lib/constants';

const render = ($target, locale, path) => {
  return $target.html(`\
<div href='${path}' class='notice notice--locale dmsans js-dismissable'> \
<div class='grid -grid'> \
<p class='-body'> \
${I18n.t('javascript.one_mubi.js_templates.locale_notice.notice', { locale })} \
<a href='${path}'> \
${I18n.t('javascript.one_mubi.js_templates.locale_notice.locale', { locale })} \
</a> \
</p> \
<a class='-dismiss js-dismiss' data-persist=\'locale-notice\' data-hours=\'1\', href='#dismiss'></a> \
</div> \
</div>\
`);
};

const currentLocationPath = () => {
  return window.location.pathname + window.location.search + window.location.hash;
};

const explicitlyDontLocalizeCurrentPath = () => {
  return window.location.pathname === '/contribute';
};

const localisePath = (path, locale = null, languageRoutes) => {
  const localePrefix = locale ? ('/' + locale) : '';
  // regex: slash followed by 2-chars then either slash or end of string
  if (/^\/[a-z]{2}(\/|$)/.test(path) && languageRoutes.includes(path.substr(1, 2))) {
    // path already contains a locale: replace with new one
    return path.replace(/^\/[a-z]{2}(\/)?/, (localePrefix + '$1')) || '/';
  } else {
    // on splash page, don't add trailing slash
    if (path === '/') { return localePrefix; } else { return (localePrefix + path); }
  }
};

const localeNotice = function() {
  const { currentLocale, preferredLocale, preferredPrefix } = window.mubiState;
  const preferredLocaleUrl = localisePath(currentLocationPath(), preferredPrefix, constants.languageRoutes);

  const wasDismissed = document.cookie.match('locale-notice');

  if (!wasDismissed && (preferredLocale !== currentLocale) && !explicitlyDontLocalizeCurrentPath()) {
    return render($('#js-locale-banner'), preferredLocale, preferredLocaleUrl);
  }
};

export default localeNotice;
